// Marketing footer — trust marks + money-back guarantee + no-CC copy visible everywhere.
// D3.4: exposes "No credit card required" + "30-day money-back guarantee" outside of noscript.
import { Link } from "react-router-dom";
import { ShieldCheck, RefreshCcw, Lock } from "lucide-react";

export const MarketingFooter = () => {
  return (
    <footer className="border-t border-border/60 bg-secondary/30 mt-16">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 py-10">
        <div className="grid gap-8 md:grid-cols-4 text-sm">
          <div>
            <p className="font-serif text-xl font-bold">Lectura<span className="text-accent">.</span></p>
            <p className="mt-2 text-muted-foreground max-w-xs">
              Name a book and chapter. Get an AI-narrated lecture, slides, printable guide, and graded quiz in under two minutes.
            </p>
            <div className="mt-4 flex flex-col gap-2 text-xs text-muted-foreground">
              <span className="inline-flex items-center gap-2" data-testid="footer-no-cc">
                <ShieldCheck className="h-3.5 w-3.5" /> Free tier — no credit card required.
              </span>
              <span className="inline-flex items-center gap-2" data-testid="footer-money-back">
                <RefreshCcw className="h-3.5 w-3.5" /> 30-day money-back guarantee on Pro plans.
              </span>
              <span className="inline-flex items-center gap-2">
                <Lock className="h-3.5 w-3.5" /> FERPA & COPPA compliant.
              </span>
            </div>
          </div>
          <div>
            <p className="font-semibold mb-3">Product</p>
            <ul className="space-y-2 text-muted-foreground">
              <li><Link to="/features" className="hover:text-foreground">Features</Link></li>
              <li><Link to="/pricing" className="hover:text-foreground">Pricing</Link></li>
              <li><Link to="/featured" className="hover:text-foreground">Featured guides</Link></li>
              <li><Link to="/for-schools" className="hover:text-foreground">For schools</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-semibold mb-3">Compare</p>
            <ul className="space-y-2 text-muted-foreground">
              <li><Link to="/vs/khanmigo" className="hover:text-foreground">Lectura vs Khanmigo</Link></li>
              <li><Link to="/vs/magicschool" className="hover:text-foreground">Lectura vs MagicSchool</Link></li>
              <li><Link to="/vs/starspark" className="hover:text-foreground">Lectura vs StarSpark AI</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-semibold mb-3">Company</p>
            <ul className="space-y-2 text-muted-foreground">
              <li><Link to="/about" className="hover:text-foreground">About</Link></li>
              <li><Link to="/customers" className="hover:text-foreground">Customers</Link></li>
              <li><Link to="/teachers-wanted" className="hover:text-foreground">Founding teachers</Link></li>
              <li><Link to="/launch" className="hover:text-foreground">Product Hunt launch</Link></li>
              <li><Link to="/login" className="hover:text-foreground">Sign in</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-border/60 flex flex-wrap items-center justify-between gap-3 text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} Lectura. Built to help students actually learn — not just get answers.</p>
          <p>Made by a student, for students &amp; teachers.</p>
        </div>
      </div>
    </footer>
  );
};

export default MarketingFooter;
